import http from './apiPort/index';

export default {
  http
};
